/* ======================  SCRIPTS ====================== */
    
    $("document").ready(setup);
    
    /*function isOverflown(element) {
        return (
            element.scrollHeight > element.clientHeight ||
            element.scrollWidth > element.clientWidth
        );
    }
    function sliderButtonsOverflow(container, buttons) {
        if (isOverflown(container)) {
            buttons.style.display = "flex";
        }
        $(window).resize(function () {
            if (isOverflown(container)) {
                buttons.style.display = "flex";
            } else {
                buttons.style.display = "none";
            }
        });
    }*/

    function setup() {
        initToTop();
        initBar();
        initProductFilters();
        initVideos();
        initFavoris();
        initNewsPage();
        initBtnTags();
        youtubeVideoHeader();
    }

    function initToTop() {
        let btn = $(".btn-topage");
    
        if ($(window).scrollTop() > 500) {
            btn.css("display", "flex");
        } else {
            btn.hide();
        }
    
        $(window).scroll(function () {
            if ($(window).scrollTop() > 500) {
                btn.css("display", "flex");
            } else {
                btn.hide();
            }
        });
    
        btn.on("click", function (e) {
            $("html, body").animate({scrollTop: 0}, "300");
        });
    }
    
    function initBar(){
        if($('.bar').length !== 0) setTimeout($('.bar').addClass("fixed"), 100);
    }
    
    function initProductFilters() {
        if ($("#productfilters")[0]) {
            if ($(".clearfilters")[0]) {
                const top = document.getElementById("productfilters").offsetTop - 1; //Getting Y of target element
                window.scrollTo(0, top);
            }
    
            $("#productfilters input[type=radio]").on("change", function () {
                $('.loader').addClass('show');
                $("#productfilters").submit();
            });
    
            $("#productype input[type=radio]").on("change", function () {
                $('.loader').addClass('show');
                let params = new URLSearchParams(new URL(window.location.href).search);
                $("#productfilters input").val("");
                params.delete("category-recipe[]");
                params.delete("job-recipe");
                params.delete("product-recipe[]");
                $("#productfilters").submit();
            });
    
            $("#productfilters input[type=checkbox]").on("change", function () {
                $('.loader').addClass('show');
                $("#productfilters").submit();
            });
    
            $(".seemore").on("click", function (e) {
                e.preventDefault();
                $(this).parent().find(".filters-filter").removeClass("hidden");
                $(this).hide();
            });
    
            $("#productfilters .filters-title").on("click", function () {
                let parent = $("#productfilters");
                if (parent.hasClass("active")) {
                    $(".filters-content").slideUp();
                    parent.removeClass("active");
                } else if (!parent.hasClass("active")) {
                    $(".filters-content").slideDown();
                    parent.addClass("active");
                }
            });
    
            $(".more-filters").on("click", function () {
                $("#productfilters").toggleClass("active");
            });
    
            $(".filters-filter .filter-button").on("click", function () {
                let parent = $(this).parent();
                if (parent.hasClass("has-childs") && parent.hasClass("open")) {
                    parent.children(".filters-childs").slideUp();
                    parent.removeClass("open");
                } else if (parent.hasClass("has-childs") && !parent.hasClass("open")) {
                    parent.children(".filters-childs").slideDown();
                    parent.addClass("open");
                }
            });
        }
    }
    
    function initVideos() {
        $(".to-video").on("click", function (event) {
            event.preventDefault();
    
            $("html, body").animate(
                {
                    scrollTop: $($.attr(this, "href")).offset().top - 100,
                },
                500
            );
        });
    }
    
    function initFavoris() {
        /**
         * favorites-updated-single
         * Fires after a favorite button has been submitted successfully
         * @param favorites - Array of post objects the user has favorited
         * @param post_id - The post ID that was updated
         * @param site_id - The site ID for the post that was updated (for multisite)
         * @param status - Whether the button was active or inactive
         */
        $(".simplefavorite-button").on("click", function (event) {
            const newelem =
                "<div class='favorite-info wysiwyg'>Vous venez d'ajouter cet élément à vos favoris, rendez vous dans votre <a href='/favoris'>espace favoris</a> ou dans le menu pour envoyer votre liste par email</div>";
            const elem = $(this);
    
            $(document).on(
                "favorites-updated-single",
                function (event, favorites, post_id, site_id, status) {
                    if (status === "active") {
                        elem.before($.parseHTML(newelem)[0]);
    
                        setTimeout(function () {
                            if ($(".favorite-info").length > 0) {
                                $(".favorite-info").remove();
                            }
                        }, 15000);
                    }
                }
            );
        });
    
        /**
         * favorites-cleared
         * Fires after all favorites have been cleared
         * @param button - The active clear button
         */
        $(document).on("favorites-cleared", function (event, button) {
            // Do stuff here as needed
            location.reload();
        });
    }
    
    function initNewsPage() {
        $('.archivelist-filters .title').click(function() {
            if($(window).width() < 760) {
                if($(this).hasClass('active')) {
                    $(this).removeClass('active');
                    $(this).next().slideUp(300);
                }else {
                    $(this).addClass('active');
                    $(this).next().slideDown(300);
                }
            }
        });
        
        // Reinitialiser
        $('.archivelist-filters .btn-reinit').click(function() {
            window.location.href = location.protocol + '//' + location.host + location.pathname;
        });
    }

    function initBtnTags() {
        $('.tag-select').on('change', function(e) {
            e.preventDefault();
            window.location.href = $(this).val();
        });
    }
    
    //Gestion vidéo youtube en BG
    // to stop the video
    function stop() {
        let video = document.getElementById("video-bg");
        video.contentWindow.postMessage(
            '{"event":"command", "func":"stopVideo", "args":""}',
            "*"
        );
    }
    
    // to pause the video
    function pause() {
        let video = document.getElementById("video-bg");
        video.contentWindow.postMessage(
            '{"event":"command", "func":"pauseVideo", "args":""}',
            "*"
        );
    }
    
    // to pause the video
    function start() {
        let video = document.getElementById("video-bg");
        video.contentWindow.postMessage(
            '{"event":"command", "func":"playVideo", "args":""}',
            "*"
        );
    }
    
    function youtubeVideoHeader() {
        if ($(".video-bg")[0]) {
            $.fn.isInViewport = function () {
                const elementTop = $(this).offset().top;
                const elementBottom = elementTop + $(this).outerHeight();
    
                const viewportTop = $(window).scrollTop();
                const viewportBottom = viewportTop + $(window).height();
    
                return elementBottom > viewportTop && elementTop < viewportBottom;
            };
    
            if ($(window).width() >= 1000 && $(".header-bg").attr("data-code") !== '') {
                $(".header-bg").prepend(
                    '<iframe title="YoutubeFrame" data-requires-vendor-consent="Youtube" data-src="https://www.youtube-nocookie.com/embed/' +
                    $(".header-bg").attr("data-code") +
                    "?rel=0&amp;autohide=1&amp;modestbranding=1&amp;wmode=transparent&amp;autoplay=1&amp;mute=1&amp;loop=1&amp;frameBorder=0&amp;controls=0&amp;showinfo=0&amp;enablejsapi=1&amp;playlist=" +
                    $(".header-bg").attr("data-code") +
                    '" id="video-bg" src="https://www.youtube-nocookie.com/embed/' +
                    $(".header-bg").attr("data-code") +
                    "?rel=0&amp;autohide=1&amp;modestbranding=1&amp;wmode=transparent&amp;autoplay=1&amp;mute=1&amp;loop=1&amp;frameBorder=0&amp;controls=0&amp;showinfo=0&amp;enablejsapi=1&amp;playlist=" +
                    $(".header-bg").attr("data-code") +
                    '" style="display: initial;"></iframe>'
                );
                start();
            }
    
            $(window).on("resize scroll", function () {
                if ($("#video-bg")[0]) {
                    if ($(window).width() < 1000) {
                        $("#video-bg")[0].remove();
                    } else if ($(window).width() >= 1000 && $("#video-bg").isInViewport()) {
                        start();
                    } else if (!$("#video-bg").isInViewport()) {
                        pause();
                    }
                } else {
                    if ($(window).width() >= 1000) {
                        $(".header-bg").prepend(
                            '<iframe title="YoutubeFrame" data-requires-vendor-consent="Youtube" data-src="https://www.youtube-nocookie.com/embed/' +
                            $(".header-bg").attr("data-code") +
                            "?rel=0&amp;autohide=1&amp;modestbranding=1&amp;wmode=transparent&amp;autoplay=1&amp;mute=1&amp;loop=1&amp;frameBorder=0&amp;controls=0&amp;showinfo=0&amp;enablejsapi=1&amp;playlist=" +
                            $(".header-bg").attr("data-code") +
                            '" id="video-bg" src="https://www.youtube-nocookie.com/embed/' +
                            $(".header-bg").attr("data-code") +
                            "?rel=0&amp;autohide=1&amp;modestbranding=1&amp;wmode=transparent&amp;autoplay=1&amp;mute=1&amp;loop=1&amp;frameBorder=0&amp;controls=0&amp;showinfo=0&amp;enablejsapi=1&amp;playlist=" +
                            $(".header-bg").attr("data-code") +
                            '" style="display: initial;"></iframe>'
                        );
                        start();
                    }
                }
            });
    
            let player;
    
            window.onYouTubeIframeAPIReady = function () {
                player = new YT.Player("video-bg", {
                    events: {
                        onReady: onPlayerReady,
                    },
                });
            };
        }
    }
